// Import Packages
import {useTranslation} from 'react-i18next';
import React, {useEffect, useState} from 'react';

// Import Material UI Elements
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {Select, MenuItem} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    header: {
        justifyContent: 'space-between',
        color: 'white',
        backgroundColor: 'var(--black-pearl)',
        fontSize: '12px'
    },
    button: {

        backgroundColor: '#ecac4b',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: "#ecac4b"
        },
        fontSize: '8px',
        marginTop: '8px',
        marginRight: '8px'
    }
}));

function AttachVariable({
                            variables,
                            setOpenVariable,
                            value,
                            updateSetVariable,
                            setConfigureModal,
                            assignIndex
                        }) {
    const {t} = useTranslation();
    const [variableList, setVariableList] = useState();

    const label = 'CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.ADVANCED-ASSIGN.';

    useEffect(() => {
        setVariableList(variables.filter((x) => value.type.includes(x.type)));
        // if (selectedVariable?.type === 'Array') {
        //     setShowIndexInput(true);
        // }

    }, [variables])

    const classes = useStyles();

    return (
        <Card style={{border: "1px solid var(--black-pearl)", marginBottom: '2%'}}>
            <CardHeader className={classes.header} titleTypographyProps={{variant: ''}} title={value.keyPath}
                        action={
                            <div>
                                <Button disabled={!value.set || value.set === ''} className={classes.button}
                                        onClick={() => setConfigureModal({isOpen: true, index: assignIndex})}>
                                    {t(label + 'CONFIGURE-DATA')}
                                </Button>
                            </div>
                        }
            />
            <CardContent style={{backgroundColor: '#ebecee'}}>
                <Select value={value.set} onChange={(e) => updateSetVariable(assignIndex, e)} variant="outlined"
                        fullWidth
                        style={{backgroundColor: '#FAFAFA'}}>
                    {variableList?.length > 0 && JSON.stringify(variableList[0]) !== '{}' ? variableList.map((item, itemI) =>
                            <MenuItem key={itemI} value={item.name}>{item.name}</MenuItem>
                        ) :
                        <MenuItem button onClick={() => setOpenVariable({type: "open", id: ""})}
                                  value="">{t('CONTENT.AUTOMS-LIST.ADD-NEW-VARIABLES')}</MenuItem>
                    }
                </Select>
            </CardContent>
        </Card>
    )
}

export default AttachVariable;
